import { cdate, now, parseCustomFieldDateToISO } from '../utils/CDate';
import { validateOptions } from '../utils/generalUtils';
import { safeEval } from '../utils/safeEval';
import { ctrlRegistry } from './CustomCtrl'

export const doRegistration = () => {
    ctrlRegistry.register('attachment', () => import('./Attachment'),
        (Attachment, { def, value, onChange, ...props }) => {
            const srcURL = value?.srcURL ?? def.srcURL;
            const destURL = value?.destURL ?? def.destURL;
            const mime = value?.mime ?? def.mime;
            const handleChange = destURL || srcURL ? undefined : onChange;
            return <Attachment filename={value?.name} mime={mime} srcURL={srcURL} destURL={destURL} onSelect={handleChange} {...props}></Attachment>
        } 
    )
    ctrlRegistry.register('checkbox', () => import('./Checkbox'),
        (Checkbox, { def, value, ...props }) => <Checkbox checked={!!value} {...props}></Checkbox>
    );
    ctrlRegistry.register('clock', () => import('./Clock'),
        (Clock, { def, ...props }) => <Clock showDate={def.showDate} showZone={def.showZone} defaultTZ={def.defaultTZ} {...props}></Clock>,
        ({ def, value, clientConfig }) => {
            let currentTime = now(clientConfig.tz);
            if (value) {
                let elapsedTime = cdate(value, clientConfig.tz).duration(currentTime);
                // TODO this may need to be formatted differently for different locales
                return `${('00' + elapsedTime.hours()).slice(-2)}:${('00' + elapsedTime.minutes()).slice(-2)}:${('00' + elapsedTime.seconds()).slice(-2)}${elapsedTime.days() > 0 ? '+' + elapsedTime.days() : ''}`;
            } else {
                return def.showDate ? currentTime.dateTimeWithSecondsFormat(def.showZone) : currentTime.timeWithSecondsFormat(def.showZone)
            }
        }
    )
    ctrlRegistry.register('colorpicker', () => import('./ColorPicker'),
        (ColorPicker, { def, href, ...props }) => <ColorPicker href={href ?? def.href} {...props}></ColorPicker>
    )
    ctrlRegistry.register('computed', () => import('./ComputedCtrl'),
        (ComputedCtrl, { ...props }, { args }) => <ComputedCtrl args={args} {...props}></ComputedCtrl>
    )
    ctrlRegistry.register('currency', () => import('./CurrencyInput'),
        (CurrencyInput, { def, href, ...props }) => <CurrencyInput min={def.min} max={def.max} href={href ?? def.href} {...props}></CurrencyInput>
    )
    ctrlRegistry.register('list', () => import('./DataList'),
        (DataList, { def, value, style, ...props },  {args }) => <DataList rowDef={def.rowdef} footerRowDef={def.footerrowdef} defaultSort={def.sort} args={args} confirmDelete={def.confirmDelete} disableAdd={def.disableAdd} disableRemove={def.disableRemove} value={value ?? []} style={{ maxHeight: '350px', ...def.style, ...style }} {...props}></DataList>,
        { defaultPrintValue: () => [] }
    )
    ctrlRegistry.register('table', () => import('./DataTable'),
        (DataTable, { def, value, style, ...props }, { args }) => {
            return <DataTable columns={def.columns} defaultSort={def.sort ?? []} args={args} emptyMessage={def.emptyMessage} confirmDelete={def.confirmDelete} value={value ?? []} disableAdd={def.disableAdd} disableRemove={def.disableRemove} style={{ maxHeight: '350px', ...def.style, ...style }} {...props}></DataTable>
        },
        { defaultPrintValue: () => [] }
    )
    ctrlRegistry.register('date', () => import('./DateInput'),
        (DateInput, { def, value, minDate, maxDate, tz, href, ...props }, { clientConfig, args }) => {
            const dateValue = parseCustomFieldDateToISO(value, args?.tz ?? def.tz ?? clientConfig.tz);
            return <DateInput tz={args?.tz ?? def.tz ?? tz} value={dateValue} minDate={args?.minDate ?? def?.minDate ?? minDate} maxDate={args?.maxDate ?? def?.maxDate ?? maxDate} href={href ?? def.href} {...props}></DateInput>
    })
    ctrlRegistry.register('dayOfWeekLabel', () => import('./DayOfWeekLabel'),
        (DayOfWeekLabel, {def, value}) => <DayOfWeekLabel value={value} tz={def.tz}></DayOfWeekLabel>
    )
    ctrlRegistry.register('datetime', () => import('./DateTimeInput'),
        (DateTimeInput, { def, minDate, maxDate, tz, href, ...props }, { args }) => <DateTimeInput tz={args?.tz ?? def.tz ?? tz} minDate={args?.minDate ?? def?.minDate ?? minDate} maxDate={args?.maxDate ?? def?.maxDate ?? maxDate} href={href ?? def.href} {...props}></DateTimeInput>
    )
    ctrlRegistry.register('button', () => import('./DefaultButton'),
        (DefaultButton, { def, value, ...props }) => <DefaultButton kind={def.kind} variant={def.variant} onClick={() => {
            safeEval(def.onClick)({ navigator }, value) }
        } {...props}></DefaultButton>
    )
    ctrlRegistry.register('email', () => import('./EmailInput'),
        (EmailInput, { def, href, ...props }) => <EmailInput maxLength={def.maxlength} href={href ?? def.href} {...props}></EmailInput>
    )
    ctrlRegistry.register('file', () => import('./FileInput'),
        (FileInput, { def, href, ...props }) => <FileInput href={href ?? def.href} {...props}></FileInput>
    )
    ctrlRegistry.register('icon', () => import('./IconPicker'),
        (IconPicker, { def, href, ...props }) => <IconPicker href={href ?? def.href} {...props}></IconPicker>
    )
    ctrlRegistry.register('image', () => import('./ImageInput'),
        (ImageInput, { def, href, ...props }) => <ImageInput width={def.width} height={def.height} defaultImage={def.defaultImage} href={href ?? def.href} {...props}></ImageInput>
    )
    ctrlRegistry.register('label', () => import('./Label'),
        (Label, { def, href, style, ...props }) => <div className={def.alignRight || def.alignEnd ? 'text-end' : null}><Label text={def.text} href={href ?? def.href} style={{ ...def.style, ...style }} {...props}></Label></div>
    )

    ctrlRegistry.register('username', () => import('./Label'),
        (Label, { def, href, value, ...props }) => <Label text={value} href={href ?? def.href} {...props}></Label>
    );
    ctrlRegistry.register('datalabel', async () => {
            const Label = await import('./Label')
            return { default: Label.default, toString: ({ value, defaultValue }) => value ?? defaultValue }
        },
        (Label, { def, value, hideLabel, href, ...props }) => {
            let style;
            if (def.styles) {
                style = { ...def.styles.find(s => {
                    switch (s.operator) {
                        case '<':
                            return s.value < value;
                        case '>':
                            return s.value > value;
                        case '<=':
                            return s.value <= value;
                        case '>=':
                            return s.value >= value;
                        case '==':
                            return s.value == value;
                        case '!=':
                            return s.value != value;
                        default:
                            return false;
                    }
                })?.style };
                if (style?.fontSize) {
                    style.fontSize += 'pt';
                }
                if (style.bold) {
                    style.fontWeight = 'bold';
                    delete style.bold;
                }
                if (style.italic) {
                    style.fontStyle = 'italic';
                    delete style.italic;
                }
            }
            return <Label hideLabel={hideLabel} text={value} style={{ ...props.style, ...style }} href={href ?? def.href} {...props}></Label>;
        }
    )
    ctrlRegistry.register('language', () => import('./LanguageInput'),
        (LanguageInput, { def, href, ...props }) => <LanguageInput lockdown={def.lockdown} maxLength={def.maxlength} href={href ?? def.href} {...props}></LanguageInput>
    )
    ctrlRegistry.register('number', () => import('./NumericInput'),
        (NumericInput, { def, fixedDecimalPlaces, href, ...props }, { args }) => <NumericInput min={def.min} max={def.max} step={def.step} fixedDecimalPlaces={fixedDecimalPlaces ?? args?.fixedDecimalPlaces ?? def.fixedDecimalPlaces} href={href ?? def.href} {...props}></NumericInput>
    )
    ctrlRegistry.register('phone', () => import('./PhoneInput'),
        (PhoneInput, { def, href, ...props }) => <PhoneInput maxLength={def.maxlength} href={href ?? def.href} {...props}></PhoneInput>
    )
    ctrlRegistry.register('range', () => import('./Range'),
        (Range, { def, href, ...props }) => <Range min={def.min} max={def.max} step={def.step} href={href ?? def.href} showValue={def.showValue} {...props}></Range>
    )
    ctrlRegistry.register('richtext', () => import('./RichTextEditor'),
        (RichTextEditor, { def, href, ...props }) => <RichTextEditor href={href ?? def.href} {...props}></RichTextEditor>
    )
    ctrlRegistry.register('option', () => import('./Select'),
        (Select, { value, def, href, ...props }, { args }) => {
            let options = def.options;
            if (typeof options === 'string') {
                options = safeEval(options)(value, args);
            } else if (typeof options === 'function') {
                options = options(value, args);
            }
            const hasObjectEntries = options.some(o => typeof o === 'object');
            let labelField = def.key;
            let valueField = def.value;
            if (hasObjectEntries && !labelField) {
                labelField = 'label';
            }
            if (hasObjectEntries && !valueField) {
                valueField = 'value';
            }
            validateOptions(options, labelField, valueField);
            return <Select value={value} wildcard={def.wildcard} options={options} labelField={labelField} valueField={valueField} href={href ?? def.href} {...props}></Select>
        }
    )
    ctrlRegistry.register('labelled_option', async () => {
            const Select = await import('./Select');
            return { 
                default: Select.default, 
                toString: ({ value, defaultValue, def }) => {
                    if (value === null || value === undefined) return defaultValue;
                    let options = def.options;
                    validateOptions(options, 'label', 'value');
                    return options.find(o => o.value === value)?.label ?? value;
                }
            };
        },
        (Select, { value, def, ...props }, { args }) => {
            let options = def.options;
            if (typeof options === 'string') {
                options = safeEval(options)(value, args);
            }
            validateOptions(options, 'label', 'value');
            return <Select value={value} wildcard={def.wildcard} {...props} options={def.options} labelField='label' valueField='value'></Select>
        }
    )
    ctrlRegistry.register('signature', () => import('./Signature'),
        (Signature, { def, href, ...props }) => <Signature href={href ?? def.href} {...props}></Signature>
    )
    ctrlRegistry.register('tag', () => import('./TagManager'),
        (TagManager, { def, value, href, ...props }, { args }) => {
            const defKey = def.key ?? 'text';
            const defValue = def.value ?? 'value';
            let values = def.values;
            if (typeof values === 'string') {
                values = safeEval(values)(value, args);
            }
            validateOptions(values, defKey, defValue);
            return <TagManager tags={value} values={values} labelField={defKey} valueField={defValue} href={href ?? def.href} {...props}></TagManager>
        },
        { defaultPrintValue: () => [] }
    )
    ctrlRegistry.register('textarea', () => import('./TextareaInput'),
        (TextareaInput, { def, style, href, ...props }) => <TextareaInput rows={def.rowspan} maxLength={def.maxlength} style={{ resize: 'none', ...style }} href={href ?? def.href} {...props}></TextareaInput>
    )

    ctrlRegistry.register('json', async () => {
            const TextareaInput = await import('./TextareaInput');
            return { default: TextareaInput.default, toString: ({ value, defaultValue }) => value ? JSON.stringify(value, null, 2) : defaultValue }
        },
        (TextareaInput, { value, def, href, style, live, ...props }) => <TextareaInput live={false} value={JSON.stringify(value, null, 2)} rows={def.rowspan} maxLength={def.maxlength} href={href ?? def.href} style={{ resize: 'none', ...style }} {...props}></TextareaInput>
    )
    ctrlRegistry.register('text', () => import('./TextInput'),
        (TextInput, { def, href, maxlength, ...props }) => {
         return<TextInput maxLength={def.maxlength ?? maxlength} href={href ?? def.href} {...props}></TextInput>
        }
    )
    ctrlRegistry.register('time', () => import('./TimeInput'),
        (TimeInput, { def, minDate, maxDate, tz, href, ...props }, { args }) => <TimeInput def={args?.tz ?? def.tz ?? tz} minDate={args?.minDate ?? def?.minDate ?? minDate} maxDate={args?.maxDate ?? def?.maxDate ?? maxDate} href={href ?? def.href} {...props}></TimeInput>
    )
    ctrlRegistry.register('timezone', () => import('./TimezoneInput'),
        (TimezoneInput, { def, href, ...props }) => <TimezoneInput href={href ?? def.href} {...props}></TimezoneInput>
    )
    ctrlRegistry.register('typeahead', () => import('./TypeaheadInput'),
        (TypeaheadInput, { def, value, href, ...props}, { args }) => {
            let suggestions = def.suggestions;
            if (typeof suggestions === 'string') {
                suggestions = safeEval(suggestions)(value, args);
            }
            return <TypeaheadInput options={suggestions ?? []} lockdown={def.lockdown} value={value} href={href ?? def.href} {...props}></TypeaheadInput>
        }
    )
    ctrlRegistry.register('url', () => import('./UrlInput'),
        (UrlInput, { def, href, ...props }) => <UrlInput href={href ?? def.href} {...props}></UrlInput>
    )
    ctrlRegistry.register('hidden', () => Promise.resolve({ default: null, toString: () => null }),
        { defaultPrintValue: () => '' }
    )
    ctrlRegistry.register('address', () => import('./AddressInput'),
        (AddressInput, { def, value, onChange, ...props}) => {
            return <AddressInput address={value} onChange={(value, field) => onChange(field, value)} {...props}></AddressInput>
        },
        { defaultPrintValue: () => ({}) }
    )
    ctrlRegistry.register('gender', () => import('./GenderDropdown'),
        (GenderDropdown, { def, href, value, ...props }) => <GenderDropdown gender={value} href={href ?? def.href} {...props}></GenderDropdown>
    );
    ctrlRegistry.register('diagram', () => import('./Diagram'),
        (Diagram, { def, ...props }, {args}) => <Diagram nodeDef={def.nodeDef} {...props}></Diagram>
    )
    ctrlRegistry.register('rag', () => import('./RAGDropdown'),
        (RAGDropdown, { def, href, ...props }) => <RAGDropdown href={href ?? def.href} {...props}></RAGDropdown>
    )
    ctrlRegistry.register('unavailable', () => import('./UnavailableComponent'),
        (UnavailableComponent, { def, ...props }) => <UnavailableComponent { ...props }></UnavailableComponent>
    )
    ctrlRegistry.register('matrix', () => import('./Matrix'),
        (Matrix, { value, def, onChange, ...props }) => <Matrix value={value} ranges={def.ranges} xAxis={def.xAxis} yAxis={def.yAxis} xLabel={def.xLabel} yLabel={def.yLabel} onChange={cell => onChange?.(cell)} {...props}/>
    )

}